import { createBrowserRouter } from 'react-router'

/**
 * React Router v7 ルート定義
 *
 * レイアウト構造:
 * - root: 全ルートの親（Outlet のみ）
 *   - main-layout: 認証済みページ（AuthGuard + Header/Footer）
 *   - guide-layout: ガイドページ（公開、ヘッダー/フッター付き）
 *   - その他: landing, login, legal, auth 等（レイアウトなし）
 */
export const router = createBrowserRouter([
  {
    path: '/',
    lazy: () => import('./routes/root').then((m) => ({ Component: m.default })),
    children: [
      // Landing page (no layout)
      {
        index: true,
        lazy: () =>
          import('./routes/landing').then((m) => ({ Component: m.default })),
      },

      // Auth pages (no layout)
      {
        path: 'login',
        lazy: () =>
          import('./routes/auth/login').then((m) => ({
            Component: m.default,
          })),
      },
      {
        path: 'auth/callback',
        lazy: () =>
          import('./routes/auth/callback').then((m) => ({
            Component: m.default,
          })),
      },
      {
        path: 'auth/confirm',
        lazy: () =>
          import('./routes/auth/confirm').then((m) => ({
            Component: m.default,
          })),
      },

      // Legal pages (no layout)
      {
        path: 'tokushoho',
        lazy: () =>
          import('./routes/tokushoho').then((m) => ({
            Component: m.default,
          })),
      },
      {
        path: 'terms',
        lazy: () =>
          import('./routes/terms').then((m) => ({ Component: m.default })),
      },
      {
        path: 'privacy',
        lazy: () =>
          import('./routes/privacy').then((m) => ({ Component: m.default })),
      },

      // Guide pages (guide layout)
      {
        lazy: () =>
          import('./routes/layouts/guide-layout').then((m) => ({
            Component: m.default,
          })),
        children: [
          {
            path: 'guide',
            lazy: () =>
              import('./routes/guide').then((m) => ({
                Component: m.default,
              })),
          },
          {
            path: 'guide/:type',
            lazy: () =>
              import('./routes/guide/type').then((m) => ({
                Component: m.default,
              })),
          },
        ],
      },

      // Main app pages (main layout with auth)
      {
        lazy: () =>
          import('./routes/layouts/main-layout').then((m) => ({
            Component: m.default,
          })),
        children: [
          {
            path: 'home',
            lazy: () =>
              import('./routes/home').then((m) => ({
                Component: m.default,
              })),
          },
          {
            path: 'learn',
            lazy: () =>
              import('./routes/learn').then((m) => ({
                Component: m.default,
              })),
          },
          {
            path: 'learn/session',
            lazy: () =>
              import('./routes/learn/session').then((m) => ({
                Component: m.default,
              })),
          },
          {
            path: 'listen',
            lazy: () =>
              import('./routes/listen').then((m) => ({
                Component: m.default,
              })),
          },
          {
            path: 'stats',
            lazy: () =>
              import('./routes/stats').then((m) => ({
                Component: m.default,
              })),
          },
          {
            path: 'browse',
            lazy: () =>
              import('./routes/browse').then((m) => ({
                Component: m.default,
              })),
          },
          {
            path: 'packs',
            lazy: () =>
              import('./routes/packs').then((m) => ({
                Component: m.default,
              })),
          },
          {
            path: 'packs/:packId',
            lazy: () =>
              import('./routes/packs/detail').then((m) => ({
                Component: m.default,
              })),
          },
          {
            path: 'settings',
            lazy: () =>
              import('./routes/settings').then((m) => ({
                Component: m.default,
              })),
          },
          {
            path: 'offline',
            lazy: () =>
              import('./routes/offline').then((m) => ({
                Component: m.default,
              })),
          },
        ],
      },

      // 404 catch-all
      {
        path: '*',
        lazy: () =>
          import('./routes/not-found').then((m) => ({
            Component: m.default,
          })),
      },
    ],
  },
])
